import { generatePath } from 'react-router-dom';
import { SHORT_CONTENT_URL_FRAGMENT, SHORT_OVERVIEW_URL_FRAGMENT } from '../../constants/Navigation';
import { OVERVIEW_MODAL_PLAYLIST_PARAM, removeOverviewUrl } from '../overview';
import { PLAYLIST_SEARCH_PARAM } from '../playlistContent';
import { removeTrailingSlash } from '../../utils/RoutingUtils';
export const getShortContentUrl = ({
  shortId,
  language,
  playlistId,
  search: locationSearch
}) => {
  const searchParams = new URLSearchParams(locationSearch);
  if (playlistId) searchParams.set(PLAYLIST_SEARCH_PARAM, playlistId.toString());
  const pathname = generatePath(SHORT_CONTENT_URL_FRAGMENT, {
    shortId,
    language
  });
  const search = searchParams.toString();
  return {
    search,
    pathname,
    hash: '',
    state: undefined,
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};
export const getShortContentOverviewUrl = ({
  shortId,
  language,
  playlistId,
  overviewType,
  pathname: locationPathname = '',
  search: locationSearch
}) => {
  const searchParams = new URLSearchParams(locationSearch);
  if (playlistId) searchParams.append(OVERVIEW_MODAL_PLAYLIST_PARAM, playlistId.toString());

  // This is required for now as we need to append the new overview path to the current URL without
  // the current overview URL path. This won't be necessary when we remove routing for overviews
  const currentPathnameWithoutOverviewPath = removeTrailingSlash(removeOverviewUrl(locationPathname === '/' ? '' : locationPathname));
  const pathname = `${currentPathnameWithoutOverviewPath}${generatePath(SHORT_OVERVIEW_URL_FRAGMENT, {
    shortId,
    language,
    source: overviewType
  })}`;
  const search = searchParams.toString();
  return {
    search,
    pathname,
    hash: '',
    state: undefined,
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};